module.exports = __webpack_public_path__ + "prod/1.42.2/img/system-three-h5.f9a85e84.png";